export const second = 1000;
export const minute = 60 * second;
export const hour = 60 * minute;
export const day = 24 * hour;
export const week = 7 * day;
export const month = 30 * day;
export const year = 365.25 * day;

export const expansionRelease = {
  0: 1505667600000,
  forsaken: 1536080400000,
  shadowkeep: 1569949200000,
  beyondLight: 1605027600000,
  witchQueen: 1645549200000,
  lightfall: 1677603600000,
};

export const seasonRelease = {
  17: 1653411600000,
  18: 1661274000000,
  20: 1677603600000,
  21: 1684861200000,
  22: 1692723600000,
};
